// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__-fnTc","formControl":"addForm_formControl__5s57Z","list":"addForm_list__FDT6d","btnWrpper":"addForm_btnWrpper__h8Ugn"};